import React, { memo, useState, useEffect, useContext } from 'react';
import { Card } from 'tea-component';
import { SortBy } from 'tea-component/lib/table/addons';
import Table from './components/Table';
// import { getProjectList } from '@gp/services/project';
import { fetchStudioOverallProjectsOverviewData } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverall';
import { useRequest, useUpdateEffect } from 'ahooks';
import { context as Context } from '@gp/components/Context';
import './index.scss';
import CardSlot from '@/pages/globalpedia/components/CardSlot';
import { formatDateStr } from '@/pages/globalpedia/utils/common';

interface OverviewPropsType {
  // boStudioMap: {[keyName: string]: string[]} | null,
}

const DEFAULT_PROPS: OverviewPropsType = {
  // boStudioMap: null,
};

function Overview(props: OverviewPropsType) {
  const {
    // boStudioMap,
  } = props;

  const { filter }: StudioOverallProjectsContextType =
    useContext(Context) || {};

  const [sortsParams, setSortsParams] = useState<SortBy<any>>({
    by: 'priority',
    order: 'desc' as any,
  });
  // const [filterOfStudio, setFilterOfStudio] = useState<string[]>([]);

  const {
    loading: projectListLoading,
    data: projectList,
    run: projectListRun,
  } = useRequest(fetchStudioOverallProjectsOverviewData, { manual: true });

  const updateTimeFormatted = formatDateStr(projectList?.update_time, 'YYYY-MM');

  // 排序
  useUpdateEffect(() => {
    projectListRun({
      // @ts-ignore
      bo: /* filterOfStudio */ filter?.bo || [], // bo
      project: filter?.project || [], // project
      project_list_req: {
        sort: sortsParams?.by || '',
        sort_type: sortsParams?.order || '',
      },
    });
  }, [sortsParams?.by, sortsParams?.order]);

  // 筛选器变化
  useEffect(() => {
    /* let studio: string[] = [];
    // 找到对应的studio列表
    if (Array.isArray(filter?.bo) && filter?.bo?.length && boStudioMap) {
      for (let i = 0; i < filter?.bo?.length; i ++) {
        const t = filter?.bo?.[i];
        if (Array.isArray(boStudioMap?.[t])) {
          studio = [...studio, ...boStudioMap?.[t]];
        }
      }
    } */
    // 选择的bo对应没有studio时，传个无效的studio，页面显示no data
    // studio = (Array.isArray(filter?.bo) && filter?.bo?.length > 0 && studio?.length === 0) ? [String(Date?.now())] : studio;
    // setFilterOfStudio(studio);
    projectListRun({
      // @ts-ignore
      bo: /* studio */ filter?.bo || [], // bo
      project: filter?.project || [], // project
      project_list_req: {
        sort: sortsParams?.by || '',
        sort_type: sortsParams?.order || '',
      },
    });
  }, [filter]);

  return (
    <CardSlot
      className="dbg-studio-overall-projects-development-overview"
      title={
        <div className="dbg-studio-overall-title">
          Overview {!!updateTimeFormatted && <span className='dbg-studio-overall-title-time'>Data Time: {updateTimeFormatted}</span>}
        </div>
      }
    >
      <Table
        data={projectList}
        loading={projectListLoading}
        setSortsParams={setSortsParams}
      />
    </CardSlot>
  );
}

Overview.defaultProps = DEFAULT_PROPS;

export default memo(Overview);
